import { INTERVAL_FUND } from './FundTypes'

function isEtf(miscellaneousDetails) {
  return miscellaneousDetails && miscellaneousDetails.fundGroup === 'Retail ETF'
}

function isEtfIndex(miscellaneousDetails) {
  return miscellaneousDetails && miscellaneousDetails.layoutID === '36'
}

function isIntervalFund(fundGroup) {
  return fundGroup === INTERVAL_FUND
}

export { isEtf, isEtfIndex, isIntervalFund }
